<template>
  <div>
    <div class="row mt-2 mb-3 align-items-end" style="padding-left: 15px;">
      <div class="col pl-0">
        <div class="h4 mb-0 text-uppercase">My Repetitions</div>
      </div>
      <div class="col">
        <div class="text-right text-uppercase" v-if="repetition_count > 3">
          <a class="font-weight-bold" style="color: #00ACEE;" @click.prevent="showMoreRepetitions">See All</a>
        </div>
      </div>
    </div>
    <div class="row mt-3 mb-5 " style="border-radius:20px; padding-left: 5px;">
      <div class="col">

        <div class="row mb-2 mt-3">
        <div class="reps_card px-2 px-xl-4 mb-2" v-if="this.repetition_count == 0">
            <div class="db-report-card" style="font-style: italic; font-size: 13px; text-align: center;" >
                No reps recorded
            </div>
        </div>
        <div class="db-report-card px-2 px-xl-4 mb-2 col-12" v-for="(item, index) in reps_results" :key="index" v-else style="padding: 0px 5px 0px 25px !important;">
            <div class="row col-12 p-0">
                <div class="col-6 p-0 ">{{ '#' + (reps_results.length - index) + ' - ' + item.description }} </div>
                <div class="col-6 p-0 text-right">{{ item.createdAt | formatDate }} </div>
            </div>
            <div class="row mt-2 col-12 p-0">
                <div class="col-4 p-0" v-if="item.score"><span class="">Rating: </span>{{ item.score }}</div>
                <div class="col-4 p-0" v-else>&nbsp;</div>
                <div class="col-8 p-0 text-right"><span class="">Time on Task: </span>{{ item.timeOnTask | formatHourMin }}</div>
            </div>
            <div class="row mt-2 col-12 p-0">
                <div class="col-12 p-0"><span class="">Mentor: </span>{{ item.mentor_name }}</div>
            </div>
            <div class="row mt-2 col-12 p-0">
                <div class="col-12 p-0" v-if="item.score"><span class="" >Comment: </span>{{ item.comment }}</div>
            </div>

            <div v-if="index != 2" class="border-bottom mt-1 mb-2" style="margin-left: -20px;"></div>
        </div>
        </div>








      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import router from '../../router/index.js';
import axios from 'axios';
export default {
  props: ['menteeId'],
  data() {
    return {
      repetitions_less: [],
      reps_results: [],
      repetition_count: 0,
      repetitions: [],
    }
  },

  methods: {
     showMoreRepetitions() {
       router.push('/see-all-repetitions/' + this.menteeId);
     },
     getMyRepetitions() {
        axios.get('/desktop/mentee-recent-repetitions/' + this.$store.state.user_accountid, {
        })
        .then(response =>  {
          this.repetition_count = response.data.length;
          this.repetitions = response.data;
          if(this.repetition_count > 3) {
            for( var i=0; i< 3; i++) {
              this.repetitions_less[i] = response.data[i];
            }
          } else {
            for( var j=0; j< this.repetition_count; j++) {
                this.repetitions_less[j] = response.data[j];
            }
          }
          this.reps_results = this.repetitions_less;
        })
        .catch(function(error) {
          console.log(error);
        });
    },

  },

  created() {
    this.getMyRepetitions();
  },
}

</script>


<style scoped>
.rating-btns button,
.rating-btns label
 {
  background-color: #bfeafb;
}
.rating-btns button:focus, 
.rating-btns button:hover, 
.rating-btns button.selected_btn,
.rating-btns label:focus,
.rating-btns label:hover,
.rating-btns label.selected_option {
  border: 0;
  background-color: #00acee !important;
  box-shadow: none !important;
}
@media (max-width: 1199.98px) {
  .rating-btns button {
    padding: 4px 8px;
  }
}
.search_tasks_txtbox input {
  height: 30px;
  border-right: 0;
  width: 125px !important;
  font-size: 12px;
  border-radius: 10px;
}
.hours_overtext {
  position: absolute;
  top: -22%;
  left: 20%;
  z-index: 4;
}
input:focus, select:focus, textarea:focus, button:focus {
  border-color: #ced4da;
}
.hours_textbox span {
  border-right: 0;
  border-top-left-radius: 10px !important;
  border-bottom-left-radius: 10px !important;
}
.hours_textbox input {
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  border-left: 0;
}
@media (max-width: 1199.98px) {
  .hours_textbox span {
    padding: 6px;
  }
}
.approve_btn, .mngr_app_rep_btn {
  background-color: #00acee;
}
.approve_btn:hover, .mngr_app_rep_btn:hover {
  background-color: #00acee;
}
.rep_reply_icon {
  transform: scaleY(-1);
}
a {
  color: #00acee;
}
a:hover,
a:active,
a:focus {
  color: #00acee;
}
.clock-icon-position-middle {
  position: absolute;
  transform: translateX(-50%);
  left: 0;
  background-color: white;
}
.delete-rep-link {
  color: #F16733;
}
.rep_time_icon {
  width: 15px;
}
</style>


// WEBPACK FOOTER //
// src/components/mentee/my_repetitions.vue